import { render, staticRenderFns } from "./BoDashboard.vue?vue&type=template&id=6474680f&scoped=true&"
import script from "./BoDashboard.vue?vue&type=script&lang=js&"
export * from "./BoDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BoDashboard.vue?vue&type=style&index=0&id=6474680f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474680f",
  null
  
)

export default component.exports